import React from 'react'
import styled from 'styled-components'

type LayoutTypes = {
    className?: string,
    leftBar: JSX.Element,
    centerBar: JSX.Element,
    rightBar: JSX.Element,
}

function LayoutDesktop(props: LayoutTypes) {


    return (
        <StyledLayout className={props.className}>

            <div className='left-bar'>
                {props.leftBar}
            </div>
            <div className='main'>
                {props.centerBar}
            </div>

            <div className='right-bar'>
                {props.rightBar}
            </div>

        </StyledLayout>
    )
}


const StyledLayout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;


  .main {
    height: 100%;
    width: 58%;
    display: flex;
    flex-direction: column;

  }

  .left-bar {
    height: 100%;
    width: 19%;

  }

  .right-bar {
    height: 100%;
    width: 19%;

  }
`
export default LayoutDesktop